import { styled } from "@mui/material/styles";
import { IconButton, MenuItem, Typography } from "@mui/material";
export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  height: "50px",
  width: "50px",
  "& .MuiSvgIcon-root": {
    color: theme.palette.text.primary,
  },
}));

export const HeaderTitle = styled(Typography)({
  paddingLeft: 16,
  paddingRight: 16,
  paddingBottom: 8,
  fontFamily: "'Gotham', sans-serif",
  fontSize: "18px",
});

export const MarkAllReadText = styled(Typography)(({ theme }) => ({
  paddingLeft: 16,
  paddingRight: 16,
  paddingBottom: 8,
  marginLeft: "auto",
  fontFamily: "'Gotham', sans-serif",
  fontSize: "14px",
  color: theme.palette.text.primary,
  textDecoration: "underline",
  cursor: "pointer",
}));

export const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== "isRead",
})(({ theme, isRead }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1.5),
  marginTop: theme.spacing(1),
}));

export const NotificationContent = styled(Typography)({
  fontFamily: "'Quicksand', sans-serif",
  textWrap: "auto",
});
export const NotificationDate = styled(NotificationContent)({
  marginTop: 10,
});

export const menuPaperProps = {
  sx: {
    width: 450,
    maxHeight: 400,
    overflowY: "auto",
    borderRadius: 2,
    p: 1,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },
};
